module.exports = __webpack_public_path__ + "img/qingdu_icon.0e21fb76.gif";